import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { softwareRoadmapClassicRoute } from '@atlassian/jira-router-routes-classic-projects-routes/src/softwareRoadmapClassicRoute.tsx';
import { RoadmapSkeleton } from '@atlassian/jira-skeletons/src/ui/roadmap/RoadmapSkeleton.tsx';
import { composeLayouts } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import {
	classicSoftwareProjectLayout,
	softwareProjectLayoutCode,
} from '@atlassian/jira-software-project-layout/src/index.tsx';
import { embeddedIssuePreloadLayoutBuilder } from '@atlassian/jira-issue-preload-layout/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarSoftwareClassic from '@atlassian/jira-navigation-apps-sidebar-software-classic/src/async.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import {
	incidentExperimentTraitResource,
	incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes,
} from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import {
	forgeProjectModuleResource,
	forgeProjectModuleResourceOnNav3Only,
} from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import {
	staticProjectSidebarConnectAddonsNavigationResource,
	staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only,
} from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { horizontalNavJiraResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/horizontal-navigation/horizontal-nav-jira/index.tsx';
import {
	classicRoadmapResource,
	classicRoadmapResourceOld,
} from '@atlassian/jira-router-resources-roadmap/src/services/classic-roadmap/index.tsx';
import { LazyIssueApp } from '@atlassian/jira-lazy-issue-app/src/LazyIssueApp.tsx';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { TimelineRedirect } from './common/ui/redirect/timeline-redirect/index.tsx';
import { LazyRoadmapViewClassic } from './ui/projects/roadmap/index-old.tsx';

const getConditionalResources = () =>
	fg('optimise_timeline_routes')
		? [
				incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes,
				forgeProjectModuleResourceOnNav3Only,
				staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only,
			]
		: [
				incidentExperimentTraitResource,
				forgeProjectModuleResource,
				staticProjectSidebarConnectAddonsNavigationResource,
			];

export const softwareRoadmapClassicRouteEntry = createEntry(softwareRoadmapClassicRoute, () => ({
	group: 'classic-software',
	component: TimelineRedirect,
	skeleton: RoadmapSkeleton,

	layout: composeLayouts(
		fg('optimise_timeline_routes') ? softwareProjectLayoutCode : classicSoftwareProjectLayout,
		embeddedIssuePreloadLayoutBuilder([{ query: ['selectedIssue'] }]),
	),

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarSoftwareClassic,
		horizontal: AsyncHorizontalNavJira,
		onlyShowHorizontalOnNav4: true,
	},

	resources: [
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
		projectContextResource,
		staticSidebarShortcutsResource,
		staticProjectSidebarNavigationResource,
		...getConditionalResources(),
		horizontalNavJiraResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		resourceWithCondition2(
			() => fg('fix_corrupted_resource_state_in_cmp_timeline'),
			classicRoadmapResource,
			classicRoadmapResourceOld,
		),
	],

	preloadOptions: {
		earlyChunks: ['software-roadmap-early-entry'],
	},

	afterPaint: [LazyIssueApp],
	forPaint: [LazyAtlassianNavigation, LazyRoadmapViewClassic],
	ufoName: 'classic-roadmap',
}));
